module.exports = __webpack_public_path__ + "img/leave-request.0d048f26.jpg";